<template>
  <div>
    <Nav />
    <section class="section" id="Main" role="main">
      <div class="container">
        <h2 class="title is-2">Documents &amp; Records</h2>
        <div class="columns is-multiline">
          <div
            class="column is-one-quarter"
            v-for="(document,index) in documents"
            v-bind:key="index"
          >
            <div class="box document">
              <router-link :aria-label="`View a closeup and transcript of ${document.title}`" :to="{name: 'document', params:{document_id: document.key}}">
                <figure>
                  <img :src="fullPath(document.thumb)" :alt="`Scanned image of ${document.title}`"/>
                  <figcaption>{{document.title}}</figcaption>
                </figure>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
import Nav from "./components/Nav.vue";
import Footer from "./components/Footer.vue";
import { documents } from "./documents";

export default {
  name: "Documents",
  data() {
    return {
      documents
    };
  },
  methods: {
    fullPath: function(image) {
      return `documents/${image}`;
    }
  },
  components: {
    Nav,
    Footer
  }
};
</script>

<style scoped>

.content p {
  margin: 0 2rem !important;
}

.subconcept {
  padding-left: 3rem;
  padding-right: 3rem;
  margin-top: 1rem;
  padding-top: 1rem;
}

.subconcept-title {
  font-weight: bold;
  font-size: 1.2rem;
}

.document img {
  width: 100%;
}
</style>